/*
 * Copyright (c) 2021.
 * Md Naimul Hasan
 * naim886@gmail.com
 * 01719123886
 * www.naimbd.com
 */

import React, {useEffect, useState} from 'react';
import { Bar } from 'react-chartjs-2';
import {Link} from "react-router-dom";
import axios from "axios";
import BASEURL from "../../../Constants";

const Report = () => {
    const [report, setReport] = useState([])
    const getReport = () =>{
        axios.post(BASEURL+'/api/client/report-details', date).then(res=>{
            setReport(res.data)
            console.log(report)
        })
    }
    useEffect(() => {
        getReport()
    }, []);


    const [date, setDate] = useState([])
    const handleDateInput = (e) => {
        setDate(prev =>({...prev, [e.target.name] :e.target.value }))
    }

    const handleSearch = () => {
        setDate(prev =>({...prev, time: 'between' }))
        getReport()
    }

    const handleButtonInput = (e, time) => {
        if (time == 'all'){
            setDate(prev =>({...prev, time: 'all' }))
        }else if(time=='this'){
            setDate(prev =>({...prev, time: 'this' }))
        }else if(time=='prev'){
            setDate(prev =>({...prev, time: 'prev' }))
        }
    }

    useEffect(()=>{
        getReport()
    }, [date.time])


    return (
        <main>
            <div className="container-fluid px-4">
                <h1 className="mt-4">Report</h1>
                <ol className="breadcrumb mb-4">
                    <li className="breadcrumb-item"><Link to={'/'}>Dashboard</Link></li>
                    <li className="breadcrumb-item active">Report</li>
                </ol>



                <div className="my-card">
                    <div className="row">


                        <div className="col-md-6 text-start mb-1">
                            <button onClick={(e)=>handleButtonInput(e, 'all')} className={'btn btn-success btn-sm'}>All Time</button>
                            <button onClick={(e)=>handleButtonInput(e, 'this')} className={'btn btn-success btn-sm ms-1'}>Today</button>
                            <button onClick={(e)=>handleButtonInput(e, 'prev')} className={'btn btn-success btn-sm ms-1'}>Yesterday</button>
                        </div>
                        <div className="col-md-6 text-end mb-1">
                            <div className="row align-items-center">
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'start_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-5">
                                    <input
                                        type={'date'}
                                        className={'form-control form-control-sm'}
                                        name={'end_date'}
                                        onChange={handleDateInput}
                                    />
                                </div>
                                <div className="col-2">
                                    <button onClick={handleSearch} className={'btn btn-success btn-sm ms-1'}>Search</button>
                                </div>
                            </div>
                        </div>



                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="card bg-primary text-white">
                                                <div className="card-header">
                                                    <h5>Total Order Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.total_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Paid Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.paid_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-warning text-white">
                                                <div className="card-header">
                                                    <h5>Total Due Amount</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>$ {report.due_amount}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-4 mb-5">
                                        <div className="col-md-4">
                                            <div className="card bg-info text-white">
                                                <div className="card-header">
                                                    <h5>Total Order</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_order}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-dark text-white">
                                                <div className="card-header">
                                                    <h5>Total Provider</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_provider}</h1>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card bg-success text-white">
                                                <div className="card-header">
                                                    <h5>Total Customer</h5>
                                                </div>
                                                <div className="card-body">
                                                    <h1>{report.total_customer}</h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
};

export default Report;
